module.exports = {
  "home.description": `Tech stories in SMC. Our blog where we talk about our approach to design, technologies and development.`,
  "locale.it": `Italian`,
  "locale.en": `English`,
  "not-found": "Not Found",
  "not-found-expl": "The page you were looking for does not exist.",
  "go-back-home": "Go back home",
  "back-to-smc-it": "CORPORATE WEBSITE >",
  "this-article-is-available-also-in-alternates": `This article is also available in {alternates}`,
  "time-to-read-in-minutes": `
    {minutes, plural,
      one {one minute}
      other {{minutes} minutes}
    } read
  `,
  "related-articles": "You might also like…",
  "notify-me-when-time-is-up": `Notify me when time’s up`,
  prediction: `Prediction`,
  "prediction-will-be-verified-at": `Deadline {at}`,
  hero1: "Partner to compete",
  hero2: "Tech stories in SMC",
  categoryTitle: "{category} in SMC",
  writtenBy: "written by",
  learnMore: "Discover More",
};
